import DataProvider from './DataProvider';
import { FileRecord } from './Learning';

export enum CourseType {
    SCENARIO = 0,
    OPEN = 1
}

export type Course = {
    id: Number
    courseId: String
    name: String
    text: String
    author: any
    active: boolean
    type: CourseType
    startDate: Date,
    maxUserCount: Number
    description: String
    requirements: String
    rankingRules: String
    markCriteria: String
    jsonScenario: any
    deadline: Date      
    scenario: any
    lmsAccessList: Array<any>
    openCourseMaterials: {fileRecord: { id: number, originalFileName: string }, name: string}[];
}

export enum ScenarioLearningStatus {
    UNDEFINED = 0 ,
    STARTED = 1 ,
    FINISHED = 2,
    WAIT_FOR_ASSESSMENT = 3,
    WAIT_FOR_START = 4,
    WAIT_FOR_GROUPING = 5
}

type ScenarioLearningStatusName = {
    status: ScenarioLearningStatus,
    name: string
}

export const ScenarioLearningStatusNames: any = {};
ScenarioLearningStatusNames[ScenarioLearningStatus[ScenarioLearningStatus.UNDEFINED]] = 'Неопределен';
ScenarioLearningStatusNames[ScenarioLearningStatus[ScenarioLearningStatus.STARTED]] = 'Начат';
ScenarioLearningStatusNames[ScenarioLearningStatus[ScenarioLearningStatus.FINISHED]] = 'Пройден';
ScenarioLearningStatusNames[ScenarioLearningStatus[ScenarioLearningStatus.WAIT_FOR_ASSESSMENT]] = 'Ожидает оценки';
ScenarioLearningStatusNames[ScenarioLearningStatus[ScenarioLearningStatus.WAIT_FOR_START]] = 'Ожидает начала';
ScenarioLearningStatusNames[ScenarioLearningStatus[ScenarioLearningStatus.WAIT_FOR_GROUPING]] = 'Идет набор группы';

export enum ScenarioLearningStatusString {
    UNDEFINED = 'UNDEFINED',
    STARTED = 'STARTED',
    FINISHED = 'FINISHED',
    WAIT_FOR_ASSESSMENT = 'WAIT_FOR_ASSESSMENT',
    WAIT_FOR_START = 'WAIT_FOR_START',
    WAIT_FOR_GROUPING = 'WAIT_FOR_GROUPING'
}

export type CaseUserAssignment = {
    id: number;
    user: any;
    course: Course;
    status: ScenarioLearningStatus;
    group: number;
    mark: number;
    markCategory: string;
    courseCompletionDate: Date;
    currentScenarioItemIndex: number;
    assessment: number;
    isResultUploader: boolean;
}

export type CourseResultFile = {
    id: number;
    course: Course;
    group?: number;
    fileRecord: FileRecord;
}

export type UserGroupMark = {
    id: number,
    courseUserAssingment: {id: number}
    group: number,
    mark: number,
    files: Array<FileRecord>
}

export type FinalGroupMark = {
    id: number,
    courseUserAssingment: {id: number}
    group: number,
    finalMark: number,
    markCategory: string
}

class Courses {
    public static async getAvailable() {
        const res = await DataProvider.executeAction('courses', 'readNotDeleted', {});
        return res.data as Array<Course>;
    }

    public static async getAssignedCourses() {
        const res = await DataProvider.executeAction('caseUserAssignments', 'readAssigned', {});
        return res.data as Array<CaseUserAssignment>;
    }

    public static async getAssignmentById(id: number)
    {
        const res = await DataProvider.executeAction('caseUserAssignments', 'readAssigned', {filter: [{
            field: 'id',
            operation: 'eq',
            value: id
        }]});
        return res.data[0] as CaseUserAssignment;
    }

    public static async assignCourse(courseId: Number) {
        const res = await DataProvider.executeAction('caseUserAssignments', 'createForCurrentUser', courseId);
        return res.result as Number;
    }

    public static async createCourseResultFile(data: CourseResultFile) {
        const res = await DataProvider.executeAction('courseResultFiles', 'create', data);
        return res.errorCode as Number;
    }

    public static async getCourseResultFiles(courseId: Number){
        const res = await DataProvider.executeAction('courseResultFiles', 'readAvailable', {filter: [{
            field: 'course',
            operation: 'eq',
            value: courseId
        }]});
        return res.data as Array<CourseResultFile>;
    }

    public static async deleteCourseResultFile(data: CourseResultFile) {
        const res = await DataProvider.executeAction('courseResultFiles', 'delete', [data]);
        return res.errorCode as Number;
    }

    public static async getAssignedMarks(courseUserAssignmentId: number) {
        const res = await DataProvider.executeAction('userGroupMarks', 'read', {filter: [{field: 'course_user_assignment_id', operation: 'eq', value: courseUserAssignmentId}]});
        return res.data as Array<UserGroupMark>;
    }

    public static async getFinalGroupMark(courseId: number, group: number) {
        const res = await DataProvider.executeAction('finalGroupMarks', 'read', {filter: [
            {field: 'course_id', operation: 'eq', value: courseId},
            {field: 'group', operation: 'eq', value: group}
        ]});
        return res.data[0] as FinalGroupMark;
    }

    public static async getFinalGroupMarks(courseId: number) {
        const res = await DataProvider.executeAction('finalGroupMarks', 'read', {filter: [
            {field: 'course_id', operation: 'eq', value: courseId}
        ]});
        return res.data as FinalGroupMark[];
    }

    public static async setGroupMark(userGroupMark: UserGroupMark, newMark: number) {
        let res = await DataProvider.executeAction('userGroupMarks', 'setMark', {
            userGroupMarkId: userGroupMark.id,
            mark: newMark
        });
        if (res.error || res.errorCode) {
            throw Error();
        }
    }
}

export default Courses;